const appKey = '_movingkite';

const createKey = function(key) {
  return `${appKey}_${key}`;
};

export default {
  userName: createKey('username'),
  privacy: createKey('privacy'),
  userEmail: createKey('email'),
};
